var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.scrollUp}},[_vm._t("default"),_c('span',{staticClass:"footer__back-to-top__message"},[_vm._v(_vm._s(_vm.message))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }